import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a2b7a4d2000950014b40505_1781280813813_fb65b494/flatline_1781234253265/src/app/[slug]/page.tsx");
